// Live text-filter for lists and tables.
//
// Add data-list-search="<selector>" to any text input. On each keystroke,
// every element matching <selector> is shown or hidden based on whether its
// text content contains the typed value (case-insensitive).
//
// To toggle a parent element instead of the matched item itself (e.g. hide
// the whole <tr> when matching a specific <td>), also add
// data-list-search-parent="<ancestor-tag>" (e.g. "tr").

// Initializes client-side text filters declared with data-list-search attributes.
function initListSearches() {
  document.querySelectorAll("[data-list-search]").forEach((input) => {
    if (input._phqListSearch) return;
    input._phqListSearch = true;

    const itemsSelector = input.dataset.listSearch;
    const parentSelector = input.dataset.listSearchParent || null;

    // Filters each configured target as the user types.
    input.addEventListener("input", () => {
      const query = input.value.toLowerCase();
      document.querySelectorAll(itemsSelector).forEach((el) => {
        const target = parentSelector ? el.closest(parentSelector) : el;
        if (target)
          target.style.display = el.textContent.toLowerCase().includes(query)
            ? ""
            : "none";
      });
    });
  });
}

// Re-bind when Turbo replaces list or table markup.
document.addEventListener("turbo:load", initListSearches);
document.addEventListener("turbo:frame-load", initListSearches);
document.addEventListener("turbo:before-stream-render", () => {
  setTimeout(initListSearches, 0);
});
